import { PagenatedResponse, SearchPagenateQuery } from '@models/common';
import { Campaign } from '@models/campaign';
import { apiClient } from '.';

export const searchCampaigns = async (query?: SearchPagenateQuery) => {
  return apiClient.get<PagenatedResponse<Campaign>>(`/admin/v1/campaign`, {
    params: query,
  });
};

export const createCampaign = async (formData: FormData) => {
  return apiClient.post<Campaign>(`/admin/v1/campaign`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const updateCampaign = async (campaignId: string, formData: FormData) => {
  return apiClient.put<Campaign>(`/admin/v1/campaign/${campaignId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteCampaign = async (campaignId: string) => {
  return apiClient.delete<void>(`/admin/v1/campaign/${campaignId}`);
};
